module.exports = __webpack_public_path__ + "img/rise-2@2x.cc096e8f.png";